import React, { useState } from "react"
import isEmail from "validator/lib/isEmail"
import replace from "../../../utils/replace"
import isOnDemand from "../../../utils/isOnDemand"
import PhoneNumber, { isValidPhone } from "../../PhoneNumber"
import submitGetInTouch from "../../../utils/submitGetInTouch"
import SubmitButton from "../../SubmitButton"

import "./index.less"
import MarketingConsentCheckbox from "../../MarketingConsentCheckbox"
import submitToMailChimp from "../../../utils/submitToMailChimp"

export default ({
  toggle,
  show,
  toEmail = null,
  space = {},
  total_price = null,
  price_per_desk = null,
  displayPrice = false,
  isCms = false,
}) => {
  const [name, setName] = useState("")
  const [phone, setPhone] = useState("")
  const [email, setEmail] = useState("")
  const [message, setMessage] = useState("")
  const [formSubmitted, setFormSubmitted] = useState(false)
  const [progress, setProgress] = useState(false)
  const [marketingEmails, setMarketingEmails] = useState(true)

  const handleBgClick = () => {
    if (typeof window !== undefined && window.innerWidth > 1200) {
      toggle()
    }
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setProgress(true)

    const res = await submitGetInTouch({
      user: { name, phone, email, message },
      isCms,
      space,
      total_price,
      toEmail,
    })

    await submitToMailChimp(marketingEmails, name, email)

    setFormSubmitted(true)
    setProgress(false)
  }

  const image = isCms ? space.mainImage[0].url : space.hero_image_url

  return (
    <div
      className={`workplace-one-modal ${show ? "show" : ""}`}
      onClick={handleBgClick}
    >
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <img
          src={require("../../../images/close.svg").default}
          className={"modal-close"}
          alt="Close"
          onClick={toggle}
        />
        <div className="modal-inner">
          <div className={`form-message ${formSubmitted ? "show" : ""}`}>
            <h5>
              Thanks for getting in touch. An office space expert will reach out
              to you as soon as possible.
            </h5>
          </div>

          <div className={`form-body ${formSubmitted ? "hidden" : ""}`}>
            {image && (
              <img
                src={image}
                alt=""
                width={150}
                height={90}
                className={"ask-q-image"}
              />
            )}

            <h4 className={"mb-1"}>Get in Touch</h4>
            <p className={`title-sub ${isCms ? "mb-5" : ""}`}>
              {isCms ? space.title : replace(space.space_name)}
            </p>

            {!isCms && (
              <>
                {displayPrice ? (
                  <p className={"price-details"}>
                    {price_per_desk && (
                      <span className="font-18">
                        <strong>{price_per_desk}</strong>/desk
                      </span>
                    )}
                    {price_per_desk ? (
                      <span className="font-14">{total_price} total</span>
                    ) : (
                      <span className="font-18">
                        <strong>{total_price}</strong>/
                        {isOnDemand() ? "day" : "month"}
                      </span>
                    )}
                  </p>
                ) : (
                  <p className={"price-details"}>
                    <span className="font-14">Contact for pricing</span>
                  </p>
                )}
              </>
            )}

            <div className="form-group">
              <input
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                name={"name"}
                placeholder={"Full name *"}
                className="form-control"
              />
            </div>
            <div className="form-group">
              <input
                type="text"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                name={"email"}
                placeholder={"Email *"}
                className="form-control"
              />
            </div>
            <div className="form-group">
              <PhoneNumber
                setPhone={setPhone}
                value={phone}
                className="form-control"
                name={"phone"}
                placeholder={"Phone Number *"}
              />
            </div>
            <div className="form-group">
              <textarea
                name="message"
                value={message}
                placeholder={"Your message *"}
                onChange={(e) => setMessage(e.target.value)}
                rows="6"
                className="form-control"
              />
            </div>
          </div>

          <MarketingConsentCheckbox
            checked={marketingEmails}
            setChecked={setMarketingEmails}
          />

          <div className={`mb-0 text-end text-md-start`}>
            {!formSubmitted ? (
              <SubmitButton
                onClick={handleSubmit}
                // className={"btn btn-primary submit_get_in_touch"}
                disabled={
                  !isEmail(email) ||
                  !message ||
                  !name ||
                  !isValidPhone(phone, true)
                }
                progress={progress}
                label={"Submit"}
              />
            ) : (
              <button onClick={toggle} className={"btn btn-primary"}>
                Close
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
